export const TRANSACTION_FIRST_CREATION_BONUS_SUCCESS = "s0211";
export const TRANSACTION_PAYPAL_PAYMENT_SUCCESS = "s0212";

export const transaction = {
    [TRANSACTION_FIRST_CREATION_BONUS_SUCCESS]: {
        colorClass: "color_transaction",
        icon: "/img/balance.svg",
        langKeyHistory: "notification.contract_transaction.action",
        route: "contract.cabinet.balance",
        langKeyNotificationAction: "notification.contract_transaction.action",
        langKeyNotificationTitle: "notification.contract_transaction.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            user: data.initiatorName,
            amount: "20.00 €"
        }),
        langTitleParams: (data) => ({
            name: data.name || data.contractName
        }),
        hash: (id) => `#${id}`
    },
    [TRANSACTION_PAYPAL_PAYMENT_SUCCESS]: {
        colorClass: "color_transaction",
        icon: "/img/balance.svg",
        langKeyHistory: "notification.contract_transaction.paypal_action",
        route: "contract.cabinet.balance",
        langKeyNotificationAction: "notification.contract_transaction.paypal_action",
        langKeyNotificationTitle: "notification.contract_transaction.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            user: data.initiatorName,
            amount: "20.00 €"
        }),
        langTitleParams: (data) => ({
            name: data.name || data.contractName
        }),
        hash: (id) => `#${id}`
    }
}; 